import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  action,
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div
      className={`flex flex-col gap-4 ${
        isCenter
          ? 'items-center text-center'
          : 'md:flex-row md:items-end md:justify-between'
      }`}
    >
      <div className={isCenter ? 'max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-[0.3em] text-primary-700">
            {!isCenter && <span className="inline-block h-px w-6 bg-primary-500"></span>}
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}